import styled from 'styled-components'

export const ErrorMessage = styled.p`
  margin: 0 0 1rem 0;
  color: var(--error-color);
  text-align: center;
  font-weight: 700;
`
